import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ExportOptions, TaskExportResult, TaskExportService } from '../task-export-service';
import { TaskExportApi } from '@/infrastructure/api-functions/core-drafting-api/task-export-api';

@injectable()
export class TaskExportServiceImpl implements TaskExportService {
    constructor(
        @inject(TaskExportApi)
        private readonly _taskExportApi: TaskExportApi,
    ) {

    }

    async exportTask(options: ExportOptions): Promise<TaskExportResult> {
        const result = await this._taskExportRepository(options);
        return result;
    }

    private async _taskExportRepository(options: ExportOptions) {
        const result = await this._taskExportApi.exportTask({
            task_id: options.taskId,
        });

        return {
            filename: result.file_name,
            url: result.url,
        };
    }
}
